import { Pomodoro } from '../Models/Pomodoro';
import {
  Component,
  ElementRef,
  Injector,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import { FormControl } from '@angular/forms';
import { PomodoroRepository } from '../Models/PomodoroRepository';
import { CategoryService } from '../services/category.service';
import { TaskService } from '../services/task.service';
import { Category } from '../Models/category.model';
import * as moment from 'moment';
import { SettingService } from '../services/setting.service';
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from '@angular/animations';
import { UserService } from '../services/user.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { TodoPreventComponent } from '../dialogs/todo-prevent/todo-prevent.component';
import { TemporaryServiceService } from '../services/temporary-message.service';

@Component({
  selector: 'app-timer-and-task',
  templateUrl: './timer-and-task.component.html',
  styleUrls: ['./timer-and-task.component.css'],
  animations: [
    trigger('popOverState', [
      state(
        'show',
        style({
          opacity: 1,
        })
      ),
      state(
        'hide',
        style({
          opacity: 0,
        })
      ),
      transition('show => hide', animate('600ms ease-out')),
      transition('hide => show', animate('1000ms ease-in')),
    ]),
  ],
})
export class TimerAndTaskComponent implements OnInit, OnDestroy {
  @ViewChild('editButton') editButton: ElementRef;
  @ViewChild('focus', { static: false }) input: ElementRef;
  @ViewChild('categoryInput', { static: false }) categoryInput: ElementRef;
  @ViewChild('descriptionInput', { static: false })
  descriptionInput: ElementRef;
  @ViewChild('tasksList') tasksList: ElementRef;
  public isCategoryTagOpen = true;
  public isDescriptionTagOpen = false;
  public checkEditMode = false;
  public showAutoComplete = false;
  public category = {
    title: '',
  };
  public editArea = false;
  public selectedId: any;
  public myControl = new FormControl();
  public pomodoro = new Pomodoro();
  public pomodoroRepository: PomodoroRepository;
  public allTask: Pomodoro[];
  public haveToken: boolean;
  public check: any;
  public secondaryCheck: any;
  public beFocus = true;
  public toggleButton = true;
  public theItem: any;
  public hasGift = {
    is_valid: false,
    message: '',
  };
  public checkUserIsPremium;
  public discountCode = 'loyal100';
  public copiedToClipboard = {
    show: false,
    message: 'کد تخفیف کپی شد.',
  };
  public sortListItem = [
    {
      id: 1,
      title: 'به ترتیب لیست کارها (از بالا به پایین)',
      isSelected: true,
      isAvailable: true,
    },
    {
      id: 2,
      title: 'به ترتیب لیست کارها (از پایین به بالا)',
      isSelected: false,
      isAvailable: true,
    },
    {
      id: 3,
      title: 'به ترتیب زمان پومودورو (از زیاد به کم)',
      isSelected: false,
      isAvailable: false,
    },
    {
      id: 4,
      title: 'به ترتیب زمان پومودورو (از کم به زیاد)',
      isSelected: false,
      isAvailable: false,
    },
    {
      id: 5,
      title: 'به ترتیب اولیت اهمیت دسته بندی',
      isSelected: false,
      isAvailable: false,
    },
  ];
  constructor(
    public categoryService: CategoryService,
    injector: Injector,
    private taskService: TaskService,
    private settingService: SettingService,
    private userService: UserService,
    private router: Router,
    private dialog: MatDialog,
    private temporaryServiceService: TemporaryServiceService
  ) {
    this.pomodoroRepository = PomodoroRepository.getInstance(injector);
  }

  ngOnInit(): void {
    if (localStorage.getItem('hideTemporaryMessage') === 'true') {
      this.temporaryServiceService.hideMessage();
    }
    if (localStorage.getItem('isReverse') === null) {
      this.pomodoroRepository.isReversed = 'بالا به پایین';
    } else {
      this.pomodoroRepository.isReversed = localStorage.getItem('isReverse');
    }

    if (
      localStorage.getItem('isReverse') === 'بالا به پایین' &&
      localStorage.getItem('arrangeAddingTasks') === 'به اول لیست کارها'
    ) {
      for (let i = 0; i < this.sortListItem.length; i++) {
        this.sortListItem[i].isSelected = false;
      }
      this.pomodoroRepository.todoPomodoros =
        this.pomodoroRepository.todoPomodoros.sort((a, b) =>
          a.id > b.id ? -1 : 1
        );
      this.sortListItem[0].isSelected = true;
    } else if (
      localStorage.getItem('isReverse') === 'پایین به بالا' &&
      localStorage.getItem('arrangeAddingTasks') === 'به آخر لیست کارها'
    ) {
      this.pomodoroRepository.todoPomodoros =
        this.pomodoroRepository.todoPomodoros.sort((a, b) =>
          a.id < b.id ? -1 : 1
        );
      for (let i = 0; i < this.sortListItem.length; i++) {
        this.sortListItem[i].isSelected = false;
      }
      this.sortListItem[1].isSelected = true;
    }
    this.refreshInMidNight();
    const token = localStorage.getItem('token');
    if (token !== null) {
      this.haveToken = true;
      this.pomodoroRepository.getTokenDoneTime();
      this.getCurrentUserInfo();
      this.getTasks();
      this.getCategory();
      this.getSetting();
    } else {
      this.haveToken = false;
    }
    this.pomodoroRepository.saveToLocalStorage();
  }

  ngOnDestroy(): any {
    for (
      let i = 0;
      i < this.pomodoroRepository.todoPomodorosTopToBottom.length;
      i++
    ) {
      this.pomodoroRepository.todoPomodorosBottomToTop[i].isEdit = false;
    }
    // tslint:disable-next-line:prefer-for-of
    for (
      let i = 0;
      i < this.pomodoroRepository.todoPomodorosBottomToTop.length;
      i++
    ) {
      this.pomodoroRepository.todoPomodorosBottomToTop[i].isEdit = false;
    }
  }

  saveToCategories(i): void {
    this.pomodoroRepository.categories.push(i);
    if (this.haveToken) {
      this.categoryService
        .syncCategory(this.pomodoroRepository.categories)
        .subscribe();
      this.pomodoroRepository.save();
    }
  }

  saveToCategoriesTasks(i): void {
    if (i.category === '') {
      i.category = null;
    }
    if (i.category !== '') {
      this.pomodoroRepository.categories.push(i.category);
      i.isEdit = false;
      this.categoryService
        .syncCategory(this.pomodoroRepository.categories)
        .subscribe();
      this.pomodoroRepository.save();
    }
  }

  categoryOnBlur(i): any {
    i.isEdit = false;
  }

  addItem(): void {
    this.pomodoro.isEdit = false;
    this.pomodoroRepository.addItem(this.pomodoro);
    this.pomodoro = new Pomodoro();
  }

  removeItemFromDone(item): void {
    this.pomodoroRepository.removeFromDone(item);
    this.pomodoroRepository.getNextLongBreakTime();
  }

  removeItemFromTodo(item): void {
    this.pomodoroRepository.removeFromTodo(item);
  }

  changeDes(item): void {
    item.isEdit = !item.isEdit;
    this.pomodoroRepository.categories.push(item.category);
  }

  showInput(i: any): any {
    const todos = this.pomodoroRepository.getTodoPomodoros();
    // tslint:disable-next-line:prefer-for-of
    for (let t = 0; t < todos.length; t++) {
      const index = todos.findIndex((item) => item.id === i.id);
      if (todos[index].id === i.id) {
        todos[index].isSelected = true;
      }
      // tslint:disable-next-line:prefer-for-of
      for (
        let p = 0;
        p < this.pomodoroRepository.getTodoPomodoros().length;
        p++
      ) {
        this.pomodoroRepository.getTodoPomodoros()[p].isEdit = false;
      }
    }
    localStorage.setItem('taskId', i.id);
    i.isEdit = true;
    localStorage.setItem('taskWhoWantsToEdit', JSON.stringify(i));
    this.theItem = i;
    // @ts-ignore
    this.myControl.value = '';
    this.editArea = true;
    this.toggleButton = false;
  }

  backToDes(item): void {
    item.isEdit = false;
    this.pomodoroRepository.save();
    this.selectedId = null;
  }

  increaseCount(p: Pomodoro): void {
    this.pomodoroRepository.increaseCount(p);
  }

  decreaseCount(p: Pomodoro): void {
    this.pomodoroRepository.decreaseCount(p);
  }

  DoneCounter(): void {
    return this.pomodoroRepository.getDonePomodoros().length;
  }

  getTodoPomodoros(): any {
    return this.allTask;
  }

  // displayFn(c: Category): string {
  //   return c && c.title ? c.title : '';
  // }

  drop(event: CdkDragDrop<Pomodoro[]>): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
    this.pomodoroRepository.save();
  }

  myLog(c: Category): any {
    if (!c) {
      return '';
    }
    return c.title;
  }

  getTokenDoneTime(): any {
    this.taskService.getTodayTask().subscribe((data) => {
      this.pomodoroRepository.getTodayProp = data.data.done;
      this.pomodoroRepository.todaySumHour = data.sum_length;
      this.pomodoroRepository.finalDone = moment()
        .startOf('day')
        .add(this.pomodoroRepository.todaySumHour, 'minutes')
        .format('HH:mm');
    });
  }

  getSetting(): any {
    this.settingService.getSettingInformation().subscribe((data) => {
      this.pomodoroRepository.defaultMeasure = data.data.pomodoro_time_length;
      this.pomodoroRepository.longBreak = data.data.long_rest_time;
      this.pomodoroRepository.shortBreak = data.data.short_rest_time;
      this.pomodoroRepository.darkMode = data.data.dark_mode;
      localStorage.setItem(
        'pomoAudio',
        JSON.stringify(data.data.pomodoro_sound)
      );
      localStorage.setItem('breakAudio', JSON.stringify(data.data.rest_sound));
      this.pomodoroRepository.saveToLocalStorage();
    });
  }

  getCategory(): any {
    this.categoryService.getListOfUsersCategory().subscribe((data) => {
      this.pomodoroRepository.categories = data;
    });
  }

  getTasks(): any {
    this.taskService.getListOfUsersTask().subscribe((data) => {
      this.pomodoroRepository.todoPomodoros = data.data.todo;
      this.pomodoroRepository.donePomodoros = data.data.done;
    });
  }

  getCurrentUserInfo(): any {
    this.userService.getCurrentUserInfo().subscribe((dd) => {
      localStorage.setItem('userId', dd.id);
      localStorage.setItem('userProfile', dd.profile_photo_url);
      this.checkUserIsPremium = dd.is_premium;
      localStorage.setItem('isPremium', dd.is_premium);
      localStorage.setItem('premiumUntil', dd.premium_until);
    });
  }

  refreshInMidNight(): any {
    const now = new Date();
    const calculate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      24,
      0,
      0,
      0
    );
    // @ts-ignore
    const myTime = calculate - now;
    setTimeout(() => {
      location.reload();
    }, myTime);
  }

  copiedToClipboardAlert(): any {
    this.copiedToClipboard.show = true;
    setTimeout(() => {
      this.copiedToClipboard.show = false;
    }, 2000);
  }

  get stateName(): any {
    return this.copiedToClipboard.show ? 'show' : 'hide';
  }

  navigateToPricing(): any {
    this.router.navigateByUrl('/pricing').then();
  }

  navigateToTodoList(): any {
    this.router.navigateByUrl('/todo').then();
  }

  selectSort(item): any {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.sortListItem.length; i++) {
      this.sortListItem[i].isSelected = false;
      item.isSelected = true;
    }
    if (item.id === 1) {
      this.pomodoroRepository.isReversed = 'بالا به پایین';
      this.pomodoroRepository.arrangeAddingTasks = 'به اول لیست کارها';
      localStorage.setItem(
        'arrangeAddingTasks',
        this.pomodoroRepository.arrangeAddingTasks
      );
      localStorage.setItem('isReverse', this.pomodoroRepository.isReversed);
      this.pomodoroRepository.todoPomodorosTopToBottom =
        this.pomodoroRepository.todoPomodoros.sort((a, b) =>
          a.id > b.id ? -1 : 1
        );
      localStorage.setItem(
        'todoPomodorosTopToBottom',
        JSON.stringify(
          this.pomodoroRepository.todoPomodorosTopToBottom.sort((a, b) =>
            a.id > b.id ? -1 : 1
          )
        )
      );
      return this.pomodoroRepository.todoPomodorosTopToBottom;
      // tslint:disable-next-line:max-line-length
    } else if (item.id === 2) {
      this.pomodoroRepository.isReversed = 'پایین به بالا';
      this.pomodoroRepository.arrangeAddingTasks = 'به آخر لیست کارها';
      localStorage.setItem(
        'arrangeAddingTasks',
        this.pomodoroRepository.arrangeAddingTasks
      );
      localStorage.setItem('isReverse', this.pomodoroRepository.isReversed);
      this.pomodoroRepository.todoPomodorosBottomToTop =
        this.pomodoroRepository.todoPomodoros.sort((a, b) =>
          a.id < b.id ? -1 : 1
        );
      localStorage.setItem(
        'todoPomodorosBottomToTop',
        JSON.stringify(
          this.pomodoroRepository.todoPomodorosBottomToTop.sort((a, b) =>
            a.id < b.id ? -1 : 1
          )
        )
      );
      return this.pomodoroRepository.todoPomodorosBottomToTop;
    }
  }

  focusTaskInput(): any {
    this.input.nativeElement.focus();
  }

  openPopUp(): any {
    this.dialog.open(TodoPreventComponent);
  }

  shouldShowMessage(): boolean {
    return this.temporaryServiceService.shouldShowMessage();
  }

  closeMessage(): void {
    this.temporaryServiceService.hideMessage();
  }
}
